document.addEventListener("DOMContentLoaded", function () {
    let videoCdn = document.getElementById("video__cdn");
    let textOverlay = document.querySelector("#video-cdn-wrapper .video__text-overlay");
    let thresholdTime = 2; // Adjust this threshold as needed

    videoCdn.addEventListener("timeupdate", function () {
      let duration = videoCdn.duration;
      let currentTime = videoCdn.currentTime;

      if (duration - currentTime < thresholdTime) {
        textOverlay.classList.toggle("hidden", !videoCdn.paused);

        if (!videoCdn.paused && currentTime >= duration - 1) {
          videoCdn.pause();
          setTimeout(function () {
            textOverlay.classList.add("hidden");
            videoCdn.currentTime = 0;
            videoCdn.play();
          }, 100);
        }
      }
    });
  });